import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { toast } from 'sonner';
import { useCreateLocation } from '../api';
import { locationFormSchema, type LocationFormInput } from '../schema';
import { LocationForm } from './LocationForm';

export function CreateLocationPage() {
  const navigate = useNavigate();
  const create = useCreateLocation();
  const form = useForm<LocationFormInput>({
    resolver: zodResolver(locationFormSchema),
    mode: 'onTouched',
    defaultValues: { locationName: '' },
  });

  const onSubmit = (input: LocationFormInput) => {
    create.mutate(
      { locationName: input.locationName.trim() },
      {
        onSuccess: (res) => {
          toast.success(res?.message ?? 'Location created');
          navigate('/location-list');
        },
        onError: (err) =>
          toast.error(readErrorMessage(err) ?? 'Could not create the location.'),
      },
    );
  };

  return (
    <LocationForm
      mode="create"
      form={form}
      onSubmit={onSubmit}
      isPending={create.isPending}
      pageTitle="Create Location"
      pageDescription="Add a geographic or logical location."
    />
  );
}

function readErrorMessage(err: unknown): string | undefined {
  if (err && typeof err === 'object') {
    const a = err as { response?: { data?: { message?: string } }; message?: string };
    return a.response?.data?.message ?? a.message;
  }
  return undefined;
}
